/* gl klaviyo-band-hide 2026-10-17: toggles html.gl-nl-band-on while the newsletter band is on screen. No other effect. */
(function(){
  function init(){
    var band=document.querySelector('.newsletter[data-section-type="newsletter"]');
    if(!band||!('IntersectionObserver' in window))return;
    var root=document.documentElement;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){root.classList.toggle('gl-nl-band-on',e.isIntersecting);});
    },{threshold:0}).observe(band);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
